import moment from 'moment';

const getMemorialDayDate = (year: number): number => {
  const lastDayOfMay = moment(`5-31-${year}`, 'MM-DD-YYYY');
  const lastDayOfMayDayOfWeek = lastDayOfMay.day();
  if (lastDayOfMayDayOfWeek === 0) {
    return 25;
  }
  return 31 - (lastDayOfMayDayOfWeek - 1);
};

const isMemorialDay = (
  month: number,
  date: number,
  dayOfWeek: number,
  year: number
): boolean =>
  month === 4 && dayOfWeek === 1 && date === getMemorialDayDate(year);

export default isMemorialDay;
